import { z } from "zod"

export const pvWattsV8StationInfoSchema = z.object({
  /**
   * Latitude of the climate station.
   * Type: decimal
   */
  lat: z.number(),

  /**
   * Longitude of the climate station.
   * Type: decimal
   */
  lon: z.number(),

  /**
   * Elevation of the climate station. (meters)
   * Type: decimal
   */
  elev: z.number(),

  /**
   * Timezone offset from GMT.
   * Type: decimal
   */
  tz: z.number(),

  /**
   * ID of the climate station.
   * Type: string
   */
  location: z.string(),

  /**
   * City where climate station is located.
   * Type: string
   */
  city: z.string(),

  /**
   * State where climate station is located.
   * Type: string
   */
  state: z.string(),

  /**
   * Solar resource filename.
   * Type: string
   */
  solar_resource_file: z.string(),

  /**
   * Distance between the input location and the climate station. (meters)
   * Type: integer
   */
  distance: z.number().int(),

  /**
   * Source of the weather data used in the simulation.
   * Type: string
   */
  weather_data_source: z.string(),
})

export type PvWattsV8StationInfo = z.infer<typeof pvWattsV8StationInfoSchema>
